import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "accordion-header card-header" }
const _hoisted_6 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "badge bg-secondary me-3" }
const _hoisted_9 = { class: "m-0 me-auto" }
const _hoisted_10 = ["id", "data-bs-parent"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "card-body d-flex" }
const _hoisted_14 = { class: "m-0 p-0 pe-3 me-3 border-end d-flex align-items-center" }
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "d-flex justify-content-end gap-2 pe-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkout_modal = _resolveComponent("checkout-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-flex align-items-center px-3 border-bottom" }, [
      _createElementVNode("h5", { class: "border-0 text-center w-100" }, "Forma de pago")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("p", null, "Para continuar selecciona una opción para realizar tu pago", -1)),
      (_ctx.event.accept_bitcoin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[5] || (_cache[5] = _createElementVNode("h5", null, "Pago con Bitcoin", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCheckoutModal && _ctx.openCheckoutModal(...args))),
              disabled: _ctx.isQuoting
            }, [
              (!_ctx.isQuoting)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fab fa-bitcoin me-1" }, null, -1)),
                    _cache[2] || (_cache[2] = _createTextVNode(" Pagar ahora - ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.format_currency(null, _ctx.grand_total)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-spinner fa-spin me-1" }, null, -1)),
                    _cache[4] || (_cache[4] = _createTextVNode(" Procesando... ", -1))
                  ], 64))
            ], 8, _hoisted_2)
          ], 64))
        : _createCommentVNode("", true),
      (!!_ctx.event?.payment_options?.length)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_3, "Pago con comisiones"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "accordion mt-4",
        id: `accordion-payment-options-${_ctx.event?.id}`
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event?.payment_options, (option, ind) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "accordion-item mb-3 w-100 align-items-stretch card",
            key: option.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["align-items-center d-flex", ind == 0 ? '' : 'collapsed']),
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#collapse-${option.id}`,
                "aria-expanded": ind == 0 ? 'true' : 'false',
                "aria-controls": `collapse-${option.id}`
              }, [
                _createElementVNode("h4", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(ind + 1), 1)
                ]),
                _createElementVNode("h6", _hoisted_9, [
                  _createElementVNode("strong", null, _toDisplayString(option.name), 1)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-chevron-down ms-3" }, null, -1))
              ], 10, _hoisted_6)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["accordion-collapse collapse card-body", ind == 0 ? 'show' : '']),
              id: `collapse-${option.id}`,
              "data-bs-parent": `#accordion-payment-options-${_ctx.event?.id}`
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment_discounts(option.options ?? []), (opt, ind) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card mb-3 payment-option-item",
                      key: ind
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h5", _hoisted_14, _toDisplayString(ind + 1), 1),
                        _createElementVNode("p", _hoisted_15, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.option_type_html(opt)
                          }, null, 8, _hoisted_16),
                          _cache[7] || (_cache[7] = _createTextVNode(" se descontará ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(opt.percentage) + "%", 1),
                          _cache[8] || (_cache[8] = _createTextVNode(" del valor total de la cuenta ", -1))
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: () => _ctx.selectOption(option)
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-check" }, null, -1)),
                          _cache[10] || (_cache[10] = _createTextVNode(" Seleccionar", -1))
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_18)
                ])
              ])
            ], 10, _hoisted_10)
          ]))
        }), 128))
      ], 8, _hoisted_4)
    ]),
    _createVNode(_component_checkout_modal, {
      quote: _ctx.quote,
      onClearQuote: _ctx.clearQuote,
      onRenewQuote: _ctx.openCheckoutModal,
      onPaid: _ctx.paid
    }, null, 8, ["quote", "onClearQuote", "onRenewQuote", "onPaid"])
  ], 64))
}